/**
 * Payment Flow Route
 *
 * Minimal route wrapper for the payment flow feature.
 * Replaces 1,412 lines of inline payment UI with feature-first architecture.
 */

import { createFileRoute } from '@tanstack/react-router';
import { PaymentPage } from '@/features/payment';

export const Route = createFileRoute('/_authenticated/payment/')({
  component: PaymentPage,
});
